var PersonaErrorType;
(function (PersonaErrorType) {
    PersonaErrorType["CREATE_PERSONA"] = "CREATE_PERSONA";
    PersonaErrorType["UPDATE_PERSONA"] = "UPDATE_PERSONA";
    PersonaErrorType["DELETE_PERSONA"] = "DELETE_PERSONA";
    PersonaErrorType["GET_PERSONA"] = "GET_PERSONA";
    PersonaErrorType["SET_DEFAULT_PERSONA"] = "SET_DEFAULT_PERSONA";
    PersonaErrorType["DELETE_DEFAULT_PERSONA"] = "DELETE_DEFAULT_PERSONA";
    PersonaErrorType["GET_DEFAULT_PERSONA"] = "GET_DEFAULT_PERSONA";
    PersonaErrorType["CHANGE_PERSONA"] = "CHANGE_PERSONA_TO_CHAT";
    PersonaErrorType["NO_PERSONA_FOUND"] = "NO_PERSONA_FOUND";
    PersonaErrorType["NO_DEFAULT_PERSONA_FOUND"] = "NO_DEFAULT_PERSONA_FOUND";
    PersonaErrorType["NO_PERSONA_SELECTED"] = "NO_PERSONA_SELECTED";
})(PersonaErrorType || (PersonaErrorType = {}));
var LoadingForType;
(function (LoadingForType) {
    LoadingForType["createPersona"] = "CREATE_PERSONA";
    LoadingForType["updatePersona"] = "UPDATE_PERSONA";
    LoadingForType["deletePersona"] = "DELETE_PERSONA";
    LoadingForType["getPersona"] = "GET_PERSONA";
    LoadingForType["setDefaultPersona"] = "SET_DEFAULT_PERSONA";
    LoadingForType["changePersonaToChat"] = "CHANGE_PERSONA_TO_CHAT";
    LoadingForType["getPersonaById"] = "GET_PERSONA_BY_ID";
})(LoadingForType || (LoadingForType = {}));
export { LoadingForType, PersonaErrorType };
